export interface PillarArticle {
  slug: string;
  category: 'guide' | 'review' | 'shipping' | 'products' | 'sellers' | 'qc' | 'warehouse' | 'coupon' | 'legit' | 'safety' | 'buying' | 'fees' | 'alternatives';
  title: { en: string; 'pt-br': string; de: string };
  desc: { en: string; 'pt-br': string; de: string };
  image: string;
}

export const pillarArticles: PillarArticle[] = [
  {
    slug: 'cssbuy-spreadsheet-guide',
    category: 'guide',
    title: {
      en: 'What is CSSBuy Spreadsheet? Complete Guide 2026',
      'pt-br': 'O que é CSSBuy Spreadsheet? Guia Completo 2026',
      de: 'Was ist CSSBuy Spreadsheet? Kompletter Guide 2026',
    },
    desc: {
      en: 'Discover how to use the CSSBuy Spreadsheet to find products, trusted sellers and save on your purchases. Complete guide for beginners.',
      'pt-br': 'Descubra como usar o CSSBuy Spreadsheet para encontrar produtos, vendedores confiáveis e economizar nas suas compras. Guia completo para iniciantes.',
      de: 'Entdecken Sie, wie Sie das CSSBuy Spreadsheet verwenden, um Produkte, vertrauenswürdige Verkäufer zu finden und bei Ihren Einkäufen zu sparen.',
    },
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20sneaker%20flatlay%20on%20soft%20cream%20background%20with%20neatly%20arranged%20designer%20trainers%20and%20a%20notebook%20editorial%20product%20photography%20soft%20natural%20window%20light%20warm%20neutral%20tones%20clean%20aesthetic&width=800&height=480&seq=pillar-spreadsheet&orientation=landscape',
  },
  {
    slug: 'cssbuy-review',
    category: 'review',
    title: {
      en: 'CSSBuy Review: Is CSSBuy Legit and Safe?',
      'pt-br': 'CSSBuy Review: O CSSBuy é Legítimo e Seguro?',
      de: 'CSSBuy Review: Ist CSSBuy seriös und sicher?',
    },
    desc: {
      en: 'An honest and detailed CSSBuy review covering everything from ordering process to shipping, QC photos, and customer service experience.',
      'pt-br': 'Uma análise honesta e detalhada do CSSBuy cobrindo desde o processo de pedido até envio, fotos QC e experiência de atendimento ao cliente.',
      de: 'Eine ehrliche und detaillierte CSSBuy Review über Bestellprozess, Versand, QC-Fotos und Kundenservice-Erfahrungen.',
    },
    image: 'https://readdy.ai/api/search-image?query=Five%20star%20rating%20and%20magnifying%20glass%20on%20a%20product%20review%20concept%20with%20soft%20warm%20neutral%20background%20editorial%20photography%20clean%20minimal%20composition%20gentle%20natural%20light&width=800&height=480&seq=pillar-review&orientation=landscape',
  },
  {
    slug: 'cssbuy-shipping-cost',
    category: 'shipping',
    title: {
      en: 'CSSBuy Shipping Cost: Complete 2026 Guide',
      'pt-br': 'CSSBuy Shipping Cost: Guia Completo de Envio 2026',
      de: 'CSSBuy Versandkosten: Kompletter Guide 2026',
    },
    desc: {
      en: 'Everything you need to know about CSSBuy shipping methods, costs, delivery times, and tips to save money on international shipping.',
      'pt-br': 'Tudo o que você precisa saber sobre métodos de envio, custos, prazos e dicas para economizar no envio internacional do CSSBuy.',
      de: 'Alles über CSSBuy Versandmethoden, Kosten, Lieferzeiten und Tipps zum Sparen beim internationalen Versand.',
    },
    image: 'https://readdy.ai/api/search-image?query=Neatly%20stacked%20cardboard%20shipping%20boxes%20with%20packing%20tape%20and%20a%20small%20globe%20on%20a%20warm%20wooden%20table%20soft%20natural%20light%20editorial%20product%20photography%20clean%20minimal%20warm%20tones&width=800&height=480&seq=pillar-shipping&orientation=landscape',
  },
  {
    slug: 'cssbuy-products',
    category: 'products',
    title: {
      en: 'CSSBuy Products: Complete Product Finder Guide',
      'pt-br': 'CSSBuy Products: Guia Completo de Produtos',
      de: 'CSSBuy Produkte: Kompletter Produktfinder-Guide',
    },
    desc: {
      en: 'Learn how to find the best CSSBuy products across sneakers, streetwear, bags and accessories using organized product lists and filters.',
      'pt-br': 'Aprenda a encontrar os melhores produtos CSSBuy entre tênis, streetwear, bolsas e acessórios usando listas organizadas e filtros.',
      de: 'Erfahren Sie, wie Sie die besten CSSBuy Produkte aus Sneakers, Streetwear, Taschen und Accessoires mithilfe organisierter Listen und Filter finden.',
    },
    image: 'https://readdy.ai/api/search-image?query=Curated%20collection%20of%20folded%20clothing%20and%20sneakers%20arranged%20in%20a%20tidy%20grid%20on%20a%20soft%20neutral%20background%20editorial%20product%20flatlay%20warm%20natural%20light%20clean%20minimal%20aesthetic&width=800&height=480&seq=pillar-products&orientation=landscape',
  },
  {
    slug: 'cssbuy-sellers',
    category: 'sellers',
    title: {
      en: 'CSSBuy Sellers: How to Find Trusted Sellers',
      'pt-br': 'CSSBuy Sellers: Como Encontrar Vendedores Confiáveis',
      de: 'CSSBuy Verkäufer: So finden Sie vertrauenswürdige Verkäufer',
    },
    desc: {
      en: 'A practical guide to researching CSSBuy sellers, checking ratings, reading reviews and avoiding unreliable stores on Taobao and Weidian.',
      'pt-br': 'Um guia prático para pesquisar vendedores CSSBuy, verificar avaliações, ler reviews e evitar lojas não confiáveis no Taobao e Weidian.',
      de: 'Ein praktischer Leitfaden zur Recherche von CSSBuy Verkäufern, zum Prüfen von Bewertungen und zum Vermeiden unzuverlässiger Shops auf Taobao und Weidian.',
    },
    image: 'https://readdy.ai/api/search-image?query=Modern%20online%20storefront%20concept%20with%20a%20laptop%20showing%20product%20listings%20and%20a%20small%20shop%20store%20sign%20warm%20neutral%20background%20editorial%20photography%20clean%20minimal%20soft%20natural%20light&width=800&height=480&seq=pillar-sellers&orientation=landscape',
  },
  {
    slug: 'cssbuy-qc-guide',
    category: 'qc',
    title: {
      en: 'CSSBuy QC Guide: How to Check Products',
      'pt-br': 'CSSBuy QC Guide: Como Verificar Produtos',
      de: 'CSSBuy QC Guide: So prüfen Sie Produkte',
    },
    desc: {
      en: 'Understand CSSBuy QC photos, learn what to look for in quality checks, and how to spot common defects before approving your shipment.',
      'pt-br': 'Entenda as fotos QC do CSSBuy, saiba o que observar nas verificações de qualidade e como identificar defeitos comuns antes de aprovar o envio.',
      de: 'Verstehen Sie CSSBuy QC-Fotos, lernen Sie, worauf Sie bei Qualitätsprüfungen achten sollten und wie Sie häufige Mängel vor der Versandfreigabe erkennen.',
    },
    image: 'https://readdy.ai/api/search-image?query=Hand%20holding%20a%20magnifying%20glass%20over%20a%20sneaker%20detail%20inspection%20quality%20check%20concept%20on%20a%20clean%20warm%20neutral%20background%20editorial%20photography%20soft%20natural%20light&width=800&height=480&seq=pillar-qc&orientation=landscape',
  },
  {
    slug: 'cssbuy-warehouse',
    category: 'warehouse',
    title: {
      en: 'CSSBuy Warehouse: How It Works',
      'pt-br': 'CSSBuy Warehouse: Como Funciona o Armazém',
      de: 'CSSBuy Warehouse: So funktioniert das Lager',
    },
    desc: {
      en: 'Learn how the CSSBuy warehouse handles your packages, storage periods, consolidation, and how items are prepared before international shipping.',
      'pt-br': 'Saiba como o armazém do CSSBuy cuida dos seus pacotes, prazos de armazenamento, consolidação e como os itens são preparados antes do envio internacional.',
      de: 'Erfahren Sie, wie das CSSBuy Lager Ihre Pakete verwaltet, Lagerzeiten, Konsolidierung und wie Artikel vor dem internationalen Versand vorbereitet werden.',
    },
    image: 'https://readdy.ai/api/search-image?query=Bright%20organized%20warehouse%20with%20neat%20shelves%20of%20boxed%20packages%20and%20a%20worker%20with%20a%20clipboard%20warm%20neutral%20tones%20editorial%20photography%20clean%20minimal%20soft%20natural%20light&width=800&height=480&seq=pillar-warehouse&orientation=landscape',
  },
  {
    slug: 'cssbuy-coupon',
    category: 'coupon',
    title: {
      en: 'CSSBuy Coupon & Discount Code Guide',
      'pt-br': 'CSSBuy Coupon: Guia de Cupons e Descontos',
      de: 'CSSBuy Coupon & Rabattcode Guide',
    },
    desc: {
      en: 'Find out how CSSBuy coupons and discount codes work, where to find verified offers and how to avoid fake or expired promo codes.',
      'pt-br': 'Descubra como funcionam os cupons e códigos de desconto do CSSBuy, onde encontrar ofertas verificadas e como evitar códigos falsos ou expirados.',
      de: 'Erfahren Sie, wie CSSBuy Coupons und Rabattcodes funktionieren, wo Sie verifizierte Angebote finden und wie Sie gefälschte oder abgelaufene Codes vermeiden.',
    },
    image: 'https://readdy.ai/api/search-image?query=Discount%20coupon%20tag%20with%20scissors%20and%20shopping%20bags%20on%20a%20soft%20warm%20neutral%20background%20editorial%20product%20photography%20clean%20minimal%20composition%20gentle%20natural%20light&width=800&height=480&seq=pillar-coupon&orientation=landscape',
  },
  {
    slug: 'is-cssbuy-legit',
    category: 'legit',
    title: {
      en: 'Is CSSBuy Legit? What Beginners Should Know',
      'pt-br': 'O CSSBuy é Legítimo? Guia Para Iniciantes',
      de: 'Ist CSSBuy seriös? Was Anfänger wissen sollten',
    },
    desc: {
      en: 'A balanced look at whether CSSBuy is a legitimate shopping agent, how long it has operated and what real users say about their experience.',
      'pt-br': 'Uma análise equilibrada sobre se o CSSBuy é um agente de compras legítimo, há quanto tempo opera e o que usuários reais dizem sobre a experiência.',
      de: 'Ein ausgewogener Blick darauf, ob CSSBuy ein seriöser Einkaufsagent ist, wie lange er tätig ist und was echte Nutzer über ihre Erfahrungen sagen.',
    },
    image: 'https://readdy.ai/api/search-image?query=Blue%20verified%20shield%20badge%20with%20checkmark%20on%20a%20clean%20warm%20neutral%20background%20trust%20and%20verification%20concept%20editorial%20photography%20soft%20natural%20light%20minimal%20composition&width=800&height=480&seq=pillar-legit&orientation=landscape',
  },
  {
    slug: 'cssbuy-safety',
    category: 'safety',
    title: {
      en: 'CSSBuy Safety: Complete Safety Guide',
      'pt-br': 'CSSBuy Safety: Guia Completo de Segurança',
      de: 'CSSBuy Sicherheit: Kompletter Sicherheitsguide',
    },
    desc: {
      en: 'Essential safety tips for using CSSBuy, including secure payments, seller verification, and protecting your account and personal information.',
      'pt-br': 'Dicas essenciais de segurança para usar o CSSBuy, incluindo pagamentos seguros, verificação de vendedores e proteção da sua conta e informações pessoais.',
      de: 'Wichtige Sicherheitstipps für die Nutzung von CSSBuy, einschließlich sicherer Zahlungen, Verkäufer-Verifizierung und Schutz Ihres Kontos und Ihrer persönlichen Daten.',
    },
    image: 'https://readdy.ai/api/search-image?query=Padlock%20and%20shield%20symbols%20on%20a%20soft%20warm%20neutral%20background%20online%20safety%20and%20security%20concept%20editorial%20photography%20clean%20minimal%20composition%20gentle%20natural%20light&width=800&height=480&seq=pillar-safety&orientation=landscape',
  },
  {
    slug: 'cssbuy-buying-guide',
    category: 'buying',
    title: {
      en: 'CSSBuy Buying Guide for Beginners',
      'pt-br': 'CSSBuy Buying Guide: Guia de Compras para Iniciantes',
      de: 'CSSBuy Einkaufsratgeber für Anfänger',
    },
    desc: {
      en: 'A step-by-step CSSBuy buying guide covering account setup, ordering, QC approval and shipping so beginners can shop with confidence.',
      'pt-br': 'Um guia de compras passo a passo do CSSBuy cobrindo criação de conta, pedidos, aprovação QC e envio para iniciantes comprarem com confiança.',
      de: 'Ein Schritt-für-Schritt CSSBuy Einkaufsratgeber zu Kontoerstellung, Bestellung, QC-Freigabe und Versand, damit Anfänger sicher einkaufen können.',
    },
    image: 'https://readdy.ai/api/search-image?query=Shopping%20cart%20with%20sneaker%20boxes%20and%20a%20smartphone%20on%20a%20clean%20warm%20neutral%20background%20online%20shopping%20concept%20editorial%20photography%20soft%20natural%20light%20minimal%20composition&width=800&height=480&seq=pillar-buying&orientation=landscape',
  },
  {
    slug: 'cssbuy-fees',
    category: 'fees',
    title: {
      en: 'CSSBuy Fees Explained: Complete Cost Guide',
      'pt-br': 'CSSBuy Fees: Guia Completo de Taxas',
      de: 'CSSBuy Gebühren erklärt: Kompletter Kosten-Guide',
    },
    desc: {
      en: 'Understand all CSSBuy fees including service fees, shipping surcharges and payment costs so you know exactly what you are paying for.',
      'pt-br': 'Entenda todas as taxas do CSSBuy, incluindo taxas de serviço, sobretaxas de envio e custos de pagamento para saber exatamente pelo que está pagando.',
      de: 'Verstehen Sie alle CSSBuy Gebühren, einschließlich Servicegebühren, Versandzuschlägen und Zahlungskosten, damit Sie genau wissen, wofür Sie zahlen.',
    },
    image: 'https://readdy.ai/api/search-image?query=Calculator%20and%20receipt%20with%20coins%20on%20a%20soft%20warm%20neutral%20background%20cost%20calculation%20concept%20editorial%20photography%20clean%20minimal%20composition%20gentle%20natural%20light&width=800&height=480&seq=pillar-fees&orientation=landscape',
  },
  {
    slug: 'cssbuy-alternatives',
    category: 'alternatives',
    title: {
      en: 'CSSBuy Alternatives: Complete Comparison',
      'pt-br': 'CSSBuy Alternatives: Comparação Completa',
      de: 'CSSBuy Alternativen: Kompletter Vergleich',
    },
    desc: {
      en: 'Compare CSSBuy with other popular shopping agents on pricing, features, shipping options and customer support to find the best fit for you.',
      'pt-br': 'Compare o CSSBuy com outros agentes de compras populares em preços, recursos, opções de envio e suporte para encontrar a melhor opção.',
      de: 'Vergleichen Sie CSSBuy mit anderen beliebten Einkaufsagenten bei Preisen, Funktionen, Versandoptionen und Support, um die beste Wahl zu finden.',
    },
    image: 'https://readdy.ai/api/search-image?query=Multiple%20different%20shopping%20paths%20concept%20with%20three%20arrows%20and%20small%20product%20icons%20on%20a%20soft%20warm%20neutral%20background%20editorial%20photography%20clean%20minimal%20composition%20gentle%20natural%20light&width=800&height=480&seq=pillar-alternatives&orientation=landscape',
  },
];